import Vue from 'vue'
import '../utils/jquery-3.3.1'

var Base = {};
/**
 * 时间戳转时间
 */
Base.dealWithTime=function(time){
    if(time){
        let d = new Date(time)
        let year = d.getFullYear()
        let month = d.getMonth() + 1
        let day = d.getDate()
        let hour = d.getHours()
        let minutes = d.getMinutes()
        let date = addZero(year) + "-" + 
        addZero(month) + "-" +
                    addZero(day) + " " + 
                    addZero(hour) + ":" + 
                    addZero(minutes)
        return date
    }else{
        return ''
    }
}
function addZero(value) {
    if(value<10) {
        return "0" + value
    }else {
        return value
    }
}
Base.dealWithTime2 = function(time){
    if(time){
        let d = new Date(time)
        let year = d.getFullYear()
        let month = d.getMonth() + 1
        let day = d.getDate()
        let hour = d.getHours()
        let minutes = d.getMinutes()
        let date = addZero(year) + "-" + 
                    addZero(month) + "-" +
                    addZero(day)
        return date
    }else{
        return ''
    }
}
/**
 * 时间转时间戳
 */
Base.reverseDealWithTime=function(time){
    let d = new Date(time).getTime()
    return d
}
/**
 * 是否含有中文
 */
Base.isChinese = function(temp){
    if(escape(temp).indexOf( "%u" )<0){
        return false
    }else{
        return true
    }
}
/**
 * 打开阅片工具
 */
Base.openCateyes= function(data, show=true){
    // return window.open('/cateyes/cateyes.html?studyIds='+data+'&show='+show?'true':'false')
    return window.open(`/cateyes/cateyes.html?studyIds=${data}&show=${show?'true':'false'}`)
}

/**
 * 下载dic压缩包
 */
Base.downloadDcm= function(data){
    return window.open('/service/zip/dcmZip?id='+data)
}
/**
 * 去除文字html标签
 */
Base.delHtmlTag= function(str){
    return str.replace(/<[^>]+>/g,"");
}

/**
 * 影像权限
 */
Base.imagePermissions= function(){
    let data= JSON.parse(window.sessionStorage.getItem('user')).doctorInfo.imagePermissions
    let imgPerList= data.split(',')
    if(imgPerList.indexOf('DX')){
        imgPerList[imgPerList.indexOf('DX')]= 'DX,CR'
    }
    if(imgPerList.indexOf('DSA')){
        imgPerList[imgPerList.indexOf('DSA')]= 'DSA,XA'
    }
    return imgPerList.join(',')+',PT,PX,US,FC,RF,ECG,SC'
}

/**
 * 打开报告处理页面
 */
Base.openCateyesWindow= function(routeData, id, reportId, self){
    window.cateyesSingleWindow = (window.cateyesSingleWindow && (!window.cateyesSingleWindow.closed)) ? window.cateyesSingleWindow : window.open('about:blank');
    window.cateyesSingleWindow.location.href=routeData.href+'?studyIds='+ id+'&reportId='+reportId;
    window.addEventListener('message',(e)=>{
        if(e.data=='closeWriteHanding'){
            self._initData()
        }
    },false)
}

Base.SEX={
    '0':'男',
    '1':'女',
    '2':'不详'
}


/**
 * 流程状态
 * REPORT_TASK_STATUS
 */
Base.REPORT_TASK_STATUS={
    '1': '新生任务',
    '2': '待分配',
    '3': '待处理',
    '4': '正在处理',
    '5': '处理完成',
    '6': '已归档',
    '7': '已退回',
    '8': '申请取消',
    '9': '已取消'
}
/**
 * 报告状态
 * REPORT_STATUS
 */
Base.REPORT_STATUS={
    '0': '未报告',//可以写报告
    '1': '被领取',
    '2': '待审核',//写报告=》审核报告
    '3': '已完成',//没有写报告按钮
    '4': '已归档',
}

//退回原因
Base.BACK_REASON = {
    '1': '因图像质量原因被退回。',//退回影像中心
    '2': '患者信息异常。',//退回报告工作站
    '3': '图像异常。',//退回报告工作站
    '4': '部位异常。'//退回报告工作站
}

//退回原因,为了写报告页面
Base.BACK_REASON2 = {
    // '1': '因图像质量原因被退回。',//退回影像中心
    '2': '患者信息异常。',//退回报告工作站
    '3': '图像异常。',//退回报告工作站
    '4': '部位异常。'//退回报告工作站
}


Base.IMAGE_DICTIONARY= {
    'CT': 'CT',
    'MR': 'MR',
    'DX': 'DX,CR',
    'MG': 'MG',
    'DXA': 'DSA,XA',
    '其他': 'PT,PX,US,FC,RF,ECG,SC'
}

Base.FILE_TYPE = {
    'WORD.png': ['doc', 'dox'],
    'PDF.png': ['pdf'],
    'PPT.png': ['ppt', 'pptx'],
    'Excel.png': ['xls', 'xlsx'],
    // '压缩包': ['rar', 'zip', '7z']
    'RAR.png': ['rar'],
    'ZIP.png': ['zip'],
    '7z.PNG': ['7z'],
    'link.png': ['']
}
window.CateyesPubSub=$({})

export default  Base;


// WEBPACK FOOTER //
// ./src/utils/Base.js